const SI = {
  associationIncorporated: [
    "društvo"
  ],
  partnershipIncorporated: [
    "komanditna delniška družba (k.d.d.)",
    "komanditna družba (k.d.)"
  ],
  partnershipUnincorporated: [
    "družba z neomejeno odgovornostjo (d.n.o.)",
    "gospodarsko interesno združenje (g.i.z)"
  ]
};
export {
  SI as default
};
